import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import { getIdAndEmitterTypeFromZoneEmitterTypeKey } from 'App/Map/_utils/irrigationZoneEmitterTypeKeyUtil'
import type { TIrrigationActivityForPointOrZone } from 'App/Map/CurrentValuesMap/caches/StationValuesCache/StationValuesCache'
import type { TIrrigationZoneEmitterId } from 'stores/fieldAssetStore/helperTypes'

export const getEmitterTypeToSelect = ({
  pointEmitterTypes,
  selectedEmitters,
  valuesForPoint,
}: {
  pointEmitterTypes: TEmitterType[]
  selectedEmitters: TEmitterType[]
  valuesForPoint: TIrrigationActivityForPointOrZone | undefined
}) => {
  const cardEmitterTypes = Object.keys(valuesForPoint ?? {}).map(
    (irrigationZoneEmitterId) =>
      getIdAndEmitterTypeFromZoneEmitterTypeKey(irrigationZoneEmitterId as TIrrigationZoneEmitterId)
        .emitterType,
  )

  return [...cardEmitterTypes, ...selectedEmitters].find(
    (emitterType) => selectedEmitters.includes(emitterType) && pointEmitterTypes.includes(emitterType),
  )
}
